import { render, staticRenderFns } from "./PscDeficiencyDetail.vue?vue&type=template&id=05bedd20&scoped=true&"
import script from "./PscDeficiencyDetail.vue?vue&type=script&lang=js&"
export * from "./PscDeficiencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PscDeficiencyDetail.vue?vue&type=style&index=0&id=05bedd20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bedd20",
  null
  
)

export default component.exports